import type { TFunction } from 'i18next';

import {
  Ellipsis,
  Globe,
  Mobile,
  MobileSignalOut,
} from '@unified-checkout/design-system/icons/index';
import { Valu } from '@unified-checkout/design-system/icons/partners/Valu';

export const BALANCE_TYPES = {
  PENDING: 'pending',
  AVAILABLE: 'available',
  ON_ITS_WAY: 'on_its_way',
};

export const UPCOMING_BALANCE_TYPES = {
  POS: 'POS',
  ONLINE_PAYMENT: 'Online Payment',
  APP: 'App',
  VALU: 'valU',
  OTHER: 'Other',
} as const;

export const UPCOMING_BALANCES_TYPE_CONFIG = (t: TFunction) => ({
  [UPCOMING_BALANCE_TYPES.POS]: {
    label: t('innerLayout.balanceTransfers.balance.balances.upcomingTypes.pos'),
    icon: MobileSignalOut,
  },
  [UPCOMING_BALANCE_TYPES.ONLINE_PAYMENT]: {
    label: t(
      'innerLayout.balanceTransfers.balance.balances.upcomingTypes.onlinePayment'
    ),
    icon: Globe,
  },
  [UPCOMING_BALANCE_TYPES.APP]: {
    label: t('innerLayout.balanceTransfers.balance.balances.upcomingTypes.app'),
    icon: Mobile,
  },
  [UPCOMING_BALANCE_TYPES.VALU]: {
    label: t(
      'innerLayout.balanceTransfers.balance.balances.upcomingTypes.valu'
    ),
    icon: Valu,
  },
  [UPCOMING_BALANCE_TYPES.OTHER]: {
    label: t(
      'innerLayout.balanceTransfers.balance.balances.upcomingTypes.other'
    ),
    icon: Ellipsis,
  },
});

export const SUCCESS_STATUS_CODE = 200;

export const MINIMUM_TRANSFER_AMOUNT = 100;
